// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"77edfc4a","70":"6cb0267e","71":"71029b37","195":"b8ef5f74","293":"754534a2","349":"c177e088","360":"804374f8","419":"0ca0c5e4","606":"cb4f9268","621":"ee625e38","870":"2fdec4cc"}[chunkId] + ".chunk.css";
};